import yaml from 'yaml';

// this is a reduced version of the original processYaml function that lives in mod-content
// it only converts quoted strings with line breaks to block literals and removes trailing line breaks

/** Serialize a YAML document with project-standard formatting (no line wrapping). */
export function finalizeYamlDocument(doc) {
  processNode(doc.contents);

  let str = doc.toString({ indent: 2, lineWidth: 1e9 });

  // remove chomping indicators |+ and |-
  str = str.replace(/: \|[\+|\-]/g, ': |');

  return str;
}

export default function processYaml(yamlContent) {
  const doc = yaml.parseDocument(yamlContent);

  // Stringify the AST back into YAML
  return { yaml: finalizeYamlDocument(doc) };
}

const getType = node => {
  let typeSymbol = Object.getOwnPropertySymbols(node).find(
    s => s.toString() === 'Symbol(yaml.node.type)'
  );

  return typeSymbol
    ? node[typeSymbol]
        .toString()
        .match(/Symbol\(yaml\.(\w+)\)/)[1]
        .toUpperCase()
    : '';
};

const processNode = node => {
  if (node == null) return;
  const type = getType(node);

  switch (type) {
    case 'SCALAR':
    case 'PLAIN':
      const value = node.value;
      if (typeof value !== 'string') break;
      let text = value.trim();
      if (text.length > 0) {
        // if the string contains line breaks, set the node type to "BLOCK_LITERAL"
        if (
          node.type === 'QUOTE_DOUBLE' &&
          (text.includes('\n') || text.includes('\r'))
        ) {
          node.type = 'BLOCK_LITERAL';
          // remove line breaks (\n) at the end of the string
          text = text.replace(/\n$/, '');

          // replace escaped tabs with a single space
          text = text.replace(/\\t/g, ' ');
        }
        node.value = text;
      }
      break;

    case 'PAIR':
      processNode(node.value);

      break;

    case 'MAP':
    case 'SEQ':
      node.items.forEach(item => {
        processNode(item);
      });

      break;
  }
};
